import { Component, OnInit } from '@angular/core';
import { EnvironmentActions } from '@app/core/actions';
import * as fromRoot from '@app/reducers/index';
import { DialogRef, } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
@Component({
  selector: 'app-discover',
  templateUrl: './discover.component.html',
  styleUrls: ['./discover.component.scss'],
})
export class DiscoverComponent implements OnInit {
  currency: string = null;

  constructor(
    public ref: DialogRef,
    private readonly store$: Store<fromRoot.State>,
    private translateService: TranslateService,
  ) {
    this.currency = this.ref.data.countries.find((country: any) => country.countryCode === this.ref.data.countryCode)?.currency === 'eur' ? '€' : '$';
  }

  ngOnInit(): void { }

  goFreemium(): void {
    this.store$.dispatch(EnvironmentActions.OnBoarding({ onBoardingState: { discoverProModal: 'hideForNow', counter: 1, lastVisit: moment().toISOString() } }));
    this.ref.close();
  }

  goPro(): void {
    const url = this.translateService.instant('MODAL_DISCOVER_PRO_PRO_BTN_LINK');
    this.store$.dispatch(EnvironmentActions.OnBoarding({ onBoardingState: { discoverProModal: 'hide', counter: 0 }, redirectToPricing: url }));
  }
}
